import { Image, Segment } from "semantic-ui-react"

const AmirKhosrowpour = (props) => {
    return (
        <div className="eggshell">
            <h2>Amir Khosrowpour</h2>
            <Image src="/images/people/amirkhosrowpour.png" size="small" floated="left"/>
            <p>
            Pianist, composer, improviser, and swell guy, Amir Khosrowpour is what some might call "a dreamboat." 
            </p>
            <p>See more info at <a href="http://www.amirpiano.com/" target="_blank">www.amirpiano.com</a><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
        </div>
    )
}
export default AmirKhosrowpour